import Link from 'next/link';
import { useRouter } from 'next/router';

import { StyledOrderEmptyBlockWrapper } from '@/components/modules/orders-page/styled';
import { useAppSelector } from '@/store/hooks';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Button } from '@/shared/ui/button';
import { MenuBookIcon, Order2Icon } from '@/shared/ui/icons';

export const OrdersEmptyBlock = (): JSX.Element => {
    const route = useRouter();
    const cityUser = useAppSelector((state) => state.user.cityUser);
    const { t } = useTranslate();
    return (
        <StyledOrderEmptyBlockWrapper>
            <div>
                <div className="icon-block">
                    <Order2Icon />
                </div>
                <div className="title">{t('У вас еще нет заказов 🥲')}</div>
                <div className="link-block">
                    <span>
                        {t('Перейдите к')}
                        <Link href="/basket">{` ${t('корзине')} `}</Link>
                        {t('или')}
                        <Link href={`/${cityUser.slug}`}>{` ${t('каталогу')}`}</Link>,{' '}
                        {t('чтобы добавить товар себе в заказы')}
                    </span>
                </div>
                <div className="btn-block">
                    <Button
                        aria-label={t('К каталогу')}
                        onClick={() => route.push(`/${cityUser.slug}`)}
                        variant="dark"
                        icon={<MenuBookIcon />}
                    >
                        {t('К каталогу')}
                    </Button>
                </div>
            </div>
        </StyledOrderEmptyBlockWrapper>
    );
};
